export const addressTypes = {
    UNKNOWN: {label: 'Unknown', value: 'unknown'},
    HOME: {label: 'Home', value: 'home'},
    WORK: {label: 'Work', value: 'work'},
    OTHER: {label: 'Other', value: 'other'},
}

export const addressTypeOptions = [
    addressTypes.UNKNOWN,
    addressTypes.HOME,
    addressTypes.WORK,
    addressTypes.OTHER,
]
